import "./style.css"
import { useState, useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useTranslation } from "react-i18next";
import {
    revertChanges
} from "../../../actions/profile";
import { useLoading } from "../../../components/LoadingContext";
import { useParams } from "react-router-dom";
import CustomerLogin from "../../../components/auth/CustomerLogin";
import jwtDecode from "jwt-decode";
import { CheckRoundedIcon } from "../../../components/icons";

const RevertChanges = () => {
    const { t } = useTranslation();
    const { token } = useParams();
    const { showLoading, closeLoading } = useLoading();
    const [isValidToken, setIsValidToken] = useState();
    const [type, setType] = useState("email");

    const revertChangesHandler = async () => {
        showLoading(true);
        try {
            const revertChangesResponse = await revertChanges({ token }); 

            if (revertChangesResponse?.desc === "SUCCESS" && revertChangesResponse?.code === 200) {
                var dataFromToken = jwtDecode(token);
                setType(dataFromToken?.user?.type);
                localStorage.removeItem("token");
                setIsValidToken(true);
            } else {
                setIsValidToken(false);
            }
        } catch (err) {
            setIsValidToken(false);
        } finally {
            closeLoading(false); // always stop loading
        }
    };

    useEffect(() => {
        if (token) {
            (async () => {
                await revertChangesHandler();
            })();
        }
    }, [token]);

    return (
        <FrontLayout>
            <div className="bg-my-page">
                <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mt-12 tw:pt-1 tw:px-0 tw:lg:px-2">
                    <div className="custom-mx">
                        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8">
                            {isValidToken ? (
                                <>
                                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-12 tw:pt-4">
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-6 tw:flex tw:items-center tw:justify-center">
                                            <i>
                                                <CheckRoundedIcon />
                                            </i>
                                        </div>
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-0">
                                            <h5
                                                className="tw:font-bold! tw:text-center tw:text-[#212529]! tw:mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: t("revertChanges.title", {type}),
                                                }}
                                            >
                                            </h5>
                                        </div>
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-6">
                                            <p className="tw:text-center">
                                                {t("revertChanges.desc")}
                                            </p>
                                        </div>
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-4 tw:flex tw:items-center tw:justify-center">
                                            <button
                                                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 btn-login-change-email tw:flex tw:items-center tw:justify-center"
                                                data-bs-toggle="modal"
                                                data-bs-target="#login"
                                            >
                                                <p className="tw:text-center tw:my-0">
                                                    {t("revertChanges.button")}
                                                </p>
                                            </button>
                                        </div>
                                    </div>
                                    <CustomerLogin useModal={true} modalId={"login"} />
                                </>
                            ) : (
                                <>
                                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-12 tw:pt-4">
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-6 tw:flex tw:items-center tw:justify-center">
                                            <i>
                                                <CheckRoundedIcon />
                                            </i>
                                        </div>
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-0">
                                            <h5
                                                className="tw:font-bold! tw:text-center tw:text-[#212529]! tw:mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: t("revertChanges.failed.title"),
                                                }}
                                            >
                                            </h5>
                                        </div>
                                        <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-6">
                                            <p className="tw:text-center">
                                                {t("revertChanges.failed.desc")}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </FrontLayout>
    );
}

export default RevertChanges;
